module.exports = __webpack_public_path__ + "img/amostras_medicamentos_bg.9538c5f1.webp";